import SlideUpDialog from 'components/Dialoges/SlideUpDialog';
import { Box } from '@mui/material';
import styles from './tableModal.module.scss';
import { Props } from './types';
import DashboardTable from '../Table';
import { useNavigate } from 'react-router-dom';
import { PageActionButton } from 'components/Styled';

const ExpandedTableModal = ({ title, open, rows, columns, onClose, redirectUrl }: Props) => {
  const navigate = useNavigate();

  return (
    <SlideUpDialog
      open={open}
      onClose={onClose}
      title={title}
      containerClass={styles.container}
      loading={false}
      footer={
        redirectUrl ? (
          <>
            <PageActionButton
              variant='outlined'
              text={'View All'}
              onClick={() => navigate(redirectUrl)}
            />
          </>
        ) : null
      }
    >
      <Box className={styles.content}>
        <DashboardTable columns={columns} data={rows} />
      </Box>
    </SlideUpDialog>
  );
};

export default ExpandedTableModal;
